<template>
  <div>
    <h5
      :style="{
        marginBottom: '16px',
        fontWeight: 'bold',
      }"
    >
      Category
    </h5>
    <CategoryItem
      v-for="category in categoryTree"
      :checked="isSelected(category.id)"
      :checkedSubcategories="selectedCategories"
      :key="category.id"
      :category="category"
      @select="handleSelectFilters"
      @deselect="handleDeselectFilters"
    />
  </div>
</template>

<script>
import CategoryItem from "./CategoryItem.vue";
export default {
  components: { CategoryItem },
  name: "CategoryFilters",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedCategories: [],
    };
  },
  emits: ["change"],
  model: {
    prop: "value",
    event: "change",
  },
  methods: {
    handleSelectFilters(e) {
      const exists = this.selectedCategories.find((id) => id === e);
      if (!exists) {
        this.selectedCategories.push(e);
      }

      this.$emit("change", this.selectedCategories);
    },

    handleDeselectFilters(e) {
      const parent = this.categoryTree.find((cat) => cat.id === e);
      const index = this.selectedCategories.findIndex((id) => id === e);
      this.selectedCategories.splice(index, 1);

      if (parent) {
        this.selectedCategories = this.selectedCategories.filter((id) => {
          return !parent.subcategories.find((subcat) => subcat.id === id);
        });
      }

      this.$emit("change", this.selectedCategories);
    },

    isSelected(id) {
      const selected = this.selectedCategories.find((catId) => {
        const parentCat = this.categoryTree.find((cat) => cat.id === id);

        const hasSubcat = parentCat.subcategories?.find((subcat) =>
          this.selectedCategories.includes(subcat.id)
        );

        if (hasSubcat) {
          const exists = this.selectedCategories.find(
            (catId) => catId === hasSubcat.parent
          );
          if (!exists) {
            this.selectedCategories.push(id);
          }
        }

        return hasSubcat || catId === id;
      });

      return selected ? true : false;
    },
  },
  computed: {
    categoryTree() {
      const tree = this.$store.getters["categories/categoryTree"];
      const order = [
        "Merk",
        "Type fiets",
        "Prijsklasse",
        "Accupositie",
        "Motorpositie",
        "Motor type",
        "Versnellingen",
        "Ketting/riem",
        "Remmen",
        "Zithouding",
        "KBC lease goedgekeurd",
        "Aanbiedingen",
      ];

      const filteredTree = tree.filter(
        (category) =>
          category.slug !== "uncategorized" &&
          category.slug !== "tweedehands" &&
          category.slug !== "frametype"
      );

      const sortedTree = [];

      for (let index in order) {
        const category = filteredTree.find((cat) => cat.name === order[index]);
        if (category) {
          sortedTree.push(category);
        }
      }

      return sortedTree;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.selectedCategories = val;
      },
      immediate: true,
    },
  },
};
</script>
